import {
	CAN_DELETE_ISSUES,
	CAN_EDIT_ISSUES,
	CAN_MANAGE_SPRINTS,
	CAN_EDIT_BOARD_CONFIG,
	CAN_CREATE_ISSUES,
	CAN_ASSIGN_ISSUES,
	CAN_TRANSITION_ISSUES,
	CAN_BULK_CHANGE_ISSUES,
	CAN_VIEW_BOARD,
} from '../../../model/config/permissions/constants.tsx';
import type { Permissions } from '../../../model/config/permissions/types.tsx';
import type { State } from '../../types.tsx';

export const getPermissions = (state: State): Permissions => state.config.permissions;

export const canViewBoard = (state: State) => getPermissions(state)[CAN_VIEW_BOARD] || false;

export const canEditBoardConfig = (state: State) =>
	getPermissions(state)[CAN_EDIT_BOARD_CONFIG] || false;

export const canManageSprints = (state: State) =>
	getPermissions(state)[CAN_MANAGE_SPRINTS] || false;

export const canCreateIssues = (state: State) => getPermissions(state)[CAN_CREATE_ISSUES] || false;

export const canEditIssue = (state: State) => getPermissions(state)[CAN_EDIT_ISSUES] || false;

export const canDeleteIssues = (state: State) => getPermissions(state)[CAN_DELETE_ISSUES] || false;

export const canAssignIssues = (state: State) => getPermissions(state)[CAN_ASSIGN_ISSUES] || false;

export const canTransitionIssues = (state: State) =>
	getPermissions(state)[CAN_TRANSITION_ISSUES] || false;

export const canBulkEditIssues = (state: State) =>
	getPermissions(state)[CAN_BULK_CHANGE_ISSUES] || false;
